import Rete from 'rete'

import OpenaiTemplate from './OpenaiTemplate'
import CONST_SOCKET from '../../const/socket'
import lingualName from '../../const/lingualName'
import CONST_COMPONENT from '../../const/component'
import { lang } from '../../assets/lang'

const instagram_addon = window.xitFlowBuilderData.instagram_addon
var recurring_notification_addon = window.xitFlowBuilderData.recurring_notification_addon
var instagram_recurring_notification_addon = window.xitFlowBuilderData.instagram_recurring_notification_addon

var recurring_notification_display = 0;
if(!instagram_addon && recurring_notification_addon)
  recurring_notification_display = 1;
if(instagram_addon && instagram_recurring_notification_addon)
  recurring_notification_display = 1;

export default class OpenaiComponent extends Rete.Component {
  constructor(config) {
    super(CONST_COMPONENT.OPEN_AI)

    this.data.component = OpenaiTemplate
    this.socket = config ? config.sockets : null
    this.isUserInputFlowAddonAvailable = !! window.xitFlowBuilderData.user_input_flow_addon
    this.isInstagramAddonAvailable = !! window.xitFlowBuilderData.instagram_addon
    this.isRcnAddonAvailable = !! window.xitFlowBuilderData.recurring_notification_addon
    this.is_openai_addon_access = !! window.xitFlowBuilderData.is_openai_addon_access
    this.isConditionAddonAvailable = !!window.xitFlowBuilderData.messenger_bot_condition
    this.http_api_module = !! window.xitFlowBuilderData.http_api_module
  }

  builder(node) {
    node.lingualName = lingualName.OPEN_AI
    this.setConnection()

    const openaiInput = new Rete.Input(CONST_SOCKET.OPEN_AI_INPUT, lang.text_socket_input_reply, this.socket.openaiInput, true)
    const openaiOutput = new Rete.Output(CONST_SOCKET.OPEN_AI_OUTPUT, lang.text_socket_output_next, this.socket.openaiOutput, false)
    const openaiOutputButton = new Rete.Output(CONST_SOCKET.OPEN_AI_OUTPUT_BUTTON, lang.text_socket_output_buttons, this.socket.openaiOutputButton, true)
    const openaiOutputQuickreply = new Rete.Output(CONST_SOCKET.OPEN_AI_OUTPUT_QUICKREPLY, lang.text_socket_output_quick_replies, this.socket.openaiOutputQuickreply, true)

    node.addInput(openaiInput).addOutput(openaiOutput)
    
    // if (! instagram_addon) {
    //   node.addOutput(openaiOutputButton)
    // }
    
    node.addOutput(openaiOutputButton)
    node.addOutput(openaiOutputQuickreply)

    return node
  }

  // eslint-disable-next-line
  worker(node, inputs, outputs) {
    outputs[CONST_SOCKET.OPEN_AI_OUTPUT] = node.data
    outputs[CONST_SOCKET.OPEN_AI_OUTPUT_BUTTON] = node.data
  }
  
  setConnection() {
    // Text may be connected to:
    this.socket.openaiOutput.combineWith(this.socket.textInput)
    this.socket.openaiOutput.combineWith(this.socket.carouselInput)
    this.socket.openaiOutput.combineWith(this.socket.imageInput)

    // Output: Condition
    if (this.isConditionAddonAvailable) {  
      this.socket.openaiOutput.combineWith(this.socket.conditionInput)
    }

    if (!this.isInstagramAddonAvailable) {
      this.socket.openaiOutput.combineWith(this.socket.facebookMediaInput)
      this.socket.openaiOutput.combineWith(this.socket.videoInput)
      this.socket.openaiOutput.combineWith(this.socket.audioInput)
      this.socket.openaiOutput.combineWith(this.socket.fileInput)
      // this.socket.openaiOutput.combineWith(this.socket.otnInput)
    }

    if(recurring_notification_display)
      this.socket.openaiOutput.combineWith(this.socket.rcnInput)
 
    this.socket.openaiOutput.combineWith(this.socket.genericTemplateInput)
    this.socket.openaiOutput.combineWith(this.socket.ecommerceInput)
    this.socket.openaiOutput.combineWith(this.socket.componentListInput)

    if(this.http_api_module)
    {
      this.socket.openaiOutput.combineWith(this.socket.httpApiInput)
    }

    if (this.isUserInputFlowAddonAvailable) {
      this.socket.openaiOutput.combineWith(this.socket.userInputFlowInput)
    }

    // Output (Buttons): QuickReply, Buttons
    this.socket.openaiOutputButton.combineWith(this.socket.buttonInput)
    this.socket.openaiOutputQuickreply.combineWith(this.socket.quickReplyInput)    
  }
}